/** Shared booking create transform + validation for hall booking Create and raza-driven dialogs. */

export const isTotalOverrideOn = (values: Record<string, unknown>) =>
  values.overrideTotalPayable === true || values.overrideTotalPayable === "true";

export const stripEmptyNestedRazaEventIds = (lines: unknown): unknown => {
  if (!Array.isArray(lines)) return lines;
  return lines.map((line) => {
    const row = line as Record<string, unknown>;
    const ev = row.razaEventId;
    if (ev != null && String(ev).trim() !== "") {
      return { ...row, razaEventId: String(ev).trim() };
    }
    if (!("razaEventId" in row)) return row;
    const { razaEventId: _r, ...rest } = row;
    return rest;
  });
};

export type BookingCreatePrefill = {
  razaRequestId?: string;
  organiser?: string;
  itsNo?: string;
};

/** Default values for booking Create (standalone page or raza-embedded dialog). */
export const buildBookingCreateDefaultValues = (prefill?: BookingCreatePrefill) => {
  const razaRequestId = prefill?.razaRequestId?.trim() || undefined;
  return {
    overrideTotalPayable: false,
    hallBookings: [] as unknown[],
    ...(razaRequestId
      ? {
          razaRequestId,
          organiser: prefill?.organiser?.trim() || "",
          itsNo: prefill?.itsNo?.trim() || "",
        }
      : {}),
  };
};

export const transformBookingCreate = (values: Record<string, unknown>) => {
  const {
    overrideTotalPayable: _o,
    overriddenTotalPayable: _ot,
    remarks: remarksRaw,
    razaRequestId: razaReqRaw,
    mohalla: _mohalla,
    sadarat: _sadarat,
    ...rest
  } = values;

  const remarksTrim = String(remarksRaw ?? "").trim();
  const razaRequestId =
    razaReqRaw != null && String(razaReqRaw).trim() !== "" ? String(razaReqRaw).trim() : undefined;
  const base: Record<string, unknown> = {
    ...rest,
    ...(remarksTrim ? { remarks: remarksTrim } : {}),
    ...(razaRequestId ? { razaRequestId } : {}),
    hallBookings: stripEmptyNestedRazaEventIds(rest.hallBookings ?? []),
  };

  if (!isTotalOverrideOn(values)) {
    return base;
  }

  const over = Math.round(Number(values.overriddenTotalPayable) || 0);
  return {
    ...base,
    agreedTotalPayable: over,
  };
};

export const validateBookingCreation = (values: Record<string, unknown>) => {
  const errors: Record<string, string> = {};
  if (!values.organiser) {
    errors.organiser = "The organiser is required";
  }
  if (!values.phone) {
    errors.phone = "The phone number is required";
  }
  if (!values.itsNo) {
    errors.itsNo = "The ITS is required";
  }
  if (!values.razaRequestId) {
    errors.razaRequestId = "Raza request is required";
  }

  if (isTotalOverrideOn(values)) {
    const remarks = String(values.remarks ?? "").trim();
    if (!remarks) {
      errors.remarks =
        "Add booking remarks when using an agreed total that differs from calculated (e.g. khidmat rate)";
    }
    const over = Number(values.overriddenTotalPayable);
    if (!Number.isFinite(over) || over < 0) {
      errors.overriddenTotalPayable = "Enter a valid total amount";
    }
  }

  return errors;
};
